function parseVersion(version) {
  const match = String(version || '')
    .trim()
    .match(/^(\d{2})(\d{2})(\d{2})-(\d+)$/);
  if (!match) return null;
  const month = Number(match[1]);
  const day = Number(match[2]);
  const year = 2000 + Number(match[3]);
  const build = Number(match[4]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  return { year, month, day, build };
}

function compareVersions(leftVersion, rightVersion) {
  const left = parseVersion(leftVersion);
  const right = parseVersion(rightVersion);
  if (!left || !right) return null;
  if (left.year !== right.year) return left.year - right.year;
  if (left.month !== right.month) return left.month - right.month;
  if (left.day !== right.day) return left.day - right.day;
  return left.build - right.build;
}

function isNewerVersion(remoteVersion, localVersion) {
  const remote = parseVersion(remoteVersion);
  const local = parseVersion(localVersion);
  if (remote && !local) return true;
  const cmp = compareVersions(remoteVersion, localVersion);
  return cmp != null && cmp > 0;
}

/** Stamp from a real PixieAppV2 health payload. Junk, unknown, and other apps are null. */
function healthVersion(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
  if (data.status !== 'healthy') return null;
  if (data.service != null && data.service !== 'pixieappv2') return null;
  const version = typeof data.version === 'string' ? data.version.trim() : '';
  if (!parseVersion(version)) return null;
  return version;
}

/**
 * Dialog offer. availableVersion is only a trusted remote stamp, never the
 * copy already running. A missing or junk health version does not prompt.
 * A genuine non-stamp local version ("unknown", "dev", empty) still does.
 */
function versionUpdateOffer({
  remoteVersion,
  localVersion,
  cooldown = false,
} = {}) {
  if (cooldown) return { prompt: false, availableVersion: '' };
  const remote = typeof remoteVersion === 'string' ? remoteVersion.trim() : '';
  if (!parseVersion(remote)) return { prompt: false, availableVersion: '' };
  if (!isNewerVersion(remote, localVersion)) {
    return { prompt: false, availableVersion: '' };
  }
  return { prompt: true, availableVersion: remote };
}

module.exports = {
  parseVersion,
  compareVersions,
  isNewerVersion,
  healthVersion,
  versionUpdateOffer,
};
